<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn v-bind="$attrs" v-on="on">
        Config
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2 pa-2">
        Dashboard Config
      </v-card-title>
      <v-container>
        <div class="flex flex-col space-y-2.5">
          <v-text-field outlined label="date" hide-details dense type="date" :loading="gettingDashboardConfig"
                        :value="config.dashboardBeginDate"
                        @change="val => setDashboardConfig('dashboardBeginDate', val)" />
          <div class="flex space-x-2.5">
            <v-btn color="purple" :loading="gettingDashboardConfig" @click="getDashboardConfig">
              Reload
            </v-btn>
            <v-btn :loading="savingDashboardConfig" color="primary" @click="save">
              Save
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import { camelToSnake, useWatchEffect } from '../../../lib/utils'
import appAxios from '../../../extra-functions/axios.extra'


const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: '',
  data() {
    return {
      gettingDashboardConfig: false,
      savingDashboardConfig: false,
      config: {},
    }
  },
  created() {
    this.getDashboardConfig()
  },
  destroyed() {
    clearWatchEffect()
  },
  computed: {
    ...mapState({
      axios: state => appAxios(state.auth.token),
    }),
  },
  methods: {
    setDashboardConfig(key, val) {
      this.config = { ...this.config, [key]: val }
    },
    getDashboardConfig() {
      watchEffect(async (onCleanup) => {
        try {
          const controller = new AbortController()
          this.gettingDashboardConfig = true
          onCleanup(() => {
            controller.abort()
          })
          const { data } = await this.axios.get('/admin-configs', {
            signal: controller.signal,
          })
          this.setDashboardConfig('dashboardBeginDate', data.dashboard_begin_date)
        } catch (e) {
          console.error(e)
          this.$alertSwalError('oops something went wrong')
        } finally {
          this.gettingDashboardConfig = false
        }
      })
    },
    async save() {
      try {
        if (this.savingDashboardConfig) return
        this.savingDashboardConfig = true
        const data = Object.keys(this.config)
          .reduce((prev, next) => {
            prev[camelToSnake(next)] = this.config[next]
            return prev
          }, {})
        await this.axios.post('/admin-configs', data)
        this.$emit('saved')
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong')
      } finally {
        this.savingDashboardConfig = false
      }
    },
  },
}
</script>
